import React from "react"

const PaymentTypeIndicator = ({ isRecurring, planType, schedule, showIcon = true, showText = true, size = 18 }) => {
	if (!isRecurring && !showText) {
		return ""
	} else if (planType !== "paid") {
		return "-"
	} else if (!isRecurring && showText) {
		return "ชำระครั้งเดียว"
	}

	const getRecurringIcon = () => {
		if (!schedule) {
			return <img src="/icons/icons8-refresh.png" title="" alt="" width={size} height={size} />
		}

		if (schedule.status === "running") {
			return <img src="/icons/icons8-refresh.png" title="ตัดอัตโนมัติ" alt="ตัดอัตโนมัติ" width={size} height={size} />
			// } else if (schedule.status === "running" && schedule.failedCount > 0) {
			// return <img src="/icons/icons8-refresh-failed.png" alt="" width={size} height={size} />
		} else if (schedule.status === "deleted") {
			return <img src="/icons/icons8-refresh-disable.png" title="หยุดตัดอัตโนมัติ" alt="หยุดตัดอัตโนมัติ" width={size} height={size} />
		} else {
			return <img src="/icons/icons8-refresh-disable.png" title="หยุดตัดอัตโนมัติ" alt="หยุดตัดอัตโนมัติ" width={size} height={size} />
		}
	}

	if (showIcon && showText) {
		return (
			<div style={{ display: "flex", alignItems: "center", gap: 6 }}>
				{getRecurringIcon()}
				<span>ตัดอัตโนมัติ</span>
			</div>
		)
	}

	if (showIcon && !showText) {
		return getRecurringIcon()
	}

	if (!showIcon && showText) {
		return "ตัดอัตโนมัติ"
	}

	return null
}

export default PaymentTypeIndicator
